import React from 'react';
import type { ApplicantTier } from '../types/applicant';
import { applicantTierStyles } from '../utils/applicant';
type ApplicantTierBadgeProps = {
  tier: ApplicantTier;
};
export function ApplicantTierBadge({
  tier
}: ApplicantTierBadgeProps) {
  const Icon = tier.icon;
  return <span className={`inline-flex shrink-0 items-center gap-1 rounded-md border border-dashed px-2 py-0.5 text-xs font-semibold ${applicantTierStyles[tier.id].badge}`} title={`Applicant tier ${tier.level} · ${tier.name}`} data-id="element-117" data-mp="ijerkyyu4h7e">
      <Icon className="size-3" aria-hidden="true" data-id="element-118" data-mp="sgjb0r1apyki" />
      {tier.name}
    </span>;
}